import React from "react";
import RightPipe from '../components/RightPipe';
import Quote from '../components/Quote';
import alice from '../assets/photos/headshots/m-headshot-iya.png';
export default ({ isActive }) => {
  const message = "We’re leveraging artificial intelligence to integrate all kinds of clinical trial data and get better insights at scale.";
  const message2 = `How can we grab data from many places and start to learn from it? Why is the therapy working in one patient and not another? Can we design a better trial based on those insights?`;
  const quote = {
    author: 'Iya Khalil',
    position: 'Global Head of the Novartis AI Innovation Lab',
    img: alice,
    quote: [message, message2]
  }

  return (
    <div className="component fifth-component">
      <div>
        <RightPipe isActive={isActive} />
        <Quote quote={quote} isActive={isActive}  />
        <div></div>
      </div>
    </div>
  );
};
